<template>
  <section>
    <ModalSimple :ref="SIMPLE" />
    <ModalTrialToBasic :ref="TRIAL_TO_BASIC" />
    <ModalRecommendation :ref="RECOMMENDATION" />
    <ModalSecretQuestion :ref="SECRET_QUESTION" />
  </section>
</template>

<script>
import ModalTrialToBasic from './ModalTrialToBasic.vue'
import ModalSimple from './ModalSimple.vue'
import ModalRecommendation from './ModalRecommendation.vue'
import ModalSecretQuestion from './ModalSecretQuestion.vue'
import {
  APP_MODAL_OPEN,
  RECOMMENDATION,
  SIMPLE,
  TRIAL_TO_BASIC,
  SECRET_QUESTION,
} from './Enum'

/**
 * Como abrir um modal:
 * Em qualquer componente vue invoque o evento global
 * this.$root.$emit(APP_MODAL_OPEN, {
 *   modal: <SOME_MODAL_ENUM> // tipo de modal pode ser consultado na store "modalApp.js"
 *   payload: <any> // payload de acordo com o modal
 * })
 */
export default {
  components: {
    ModalTrialToBasic,
    ModalSimple,
    ModalRecommendation,
    ModalSecretQuestion,
  },

  mounted() {
    this.$root.$on(APP_MODAL_OPEN, this.onModalAppOpen)
  },

  data: () => {
    return {
      queue: [],
      RECOMMENDATION,
      SIMPLE,
      TRIAL_TO_BASIC,
      SECRET_QUESTION,
    }
  },

  watch: {
    queue() {
      if (this.queue.length >= 1 && this.queue[0].open === false) {
        this.queue[0].open = true
        this.queue[0].component.open()
        this.queue[0].component.$refs.modal.$on(
          'hidden',
          this.onHiddenModal(this.queue[0].component.$refs.modal)
        )
      }
    },
  },

  methods: {
    onModalAppOpen(data) {
      try {
        this.validateEntry(data)
        this.openModal(data)
      } catch (e) {
        this.$root.$emit('error', e)
      }
    },

    validateEntry(data) {
      if (!data.hasOwnProperty('modal')) {
        throw Object.assign(new Error('Invalid modal Payload'), {
          payload: data,
        })
      }
    },

    openModal(data) {
      if (!this.$refs.hasOwnProperty(data.modal)) {
        throw Object.assign(new Error('Unknow modal'), { payload: data })
      }

      this.$refs[data.modal].validate(data.payload)
      'options' in data && this.$refs[data.modal].setOptions(data.options)
      'on' in data && this.$refs[data.modal].setListeners(data.on)
      this.addQueue(this.$refs[data.modal])
    },
    addQueue(component) {
      const data = {
        component,
        open: false,
      }
      this.queue.push(data)
    },
    onHiddenModal(modal) {
      return () => {
        modal.$off('hidden')
        this.queue.splice(0, 1)
      }
    },
  },
}
</script>
